export default __webpack_public_path__ + "static/media/Icons_Electric_Fill_Green Icon.a94d76c1.svg";